var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 229,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.929 225.847h-3.151l-1.5-12.134h4.652l-.001 12.134z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.733 228.897h-10.162v-.129a3.954 3.954 0 0 1 1.159-2.791 3.951 3.951 0 0 1 2.797-1.157l6.206.001v4.076z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.135 222.903-2.971 1.05-5.471-10.938 4.384-1.55 4.058 11.438z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.913 225.511-9.579 3.386-.043-.121a3.955 3.955 0 0 1-.222-1.525 3.953 3.953 0 0 1 2.63-3.515l5.85-2.068 1.364 3.843zM146.842 221.773c-.071 0-.142-.007-.211-.019l-3.854-.7a1.159 1.159 0 0 1-.951-1.113c-.56-25.894 2.194-43.296 8.186-55.768a1.146 1.146 0 0 1 1.206-.637l13.859 1.997a1.16 1.16 0 0 1 .984 1.013l1.222 10.753a.886.886 0 0 0 .036.17l13.287 39.74c.091.289.065.602-.073.872s-.376.476-.663.573l-3.591 1.195a1.163 1.163 0 0 1-1.401-.58l-17.973-33.829a.386.386 0 0 0-.721.09l-8.216 35.335a1.151 1.151 0 0 1-1.126.908z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.888 143.202c.032.138.053.279.062.42l11.043 6.359 2.684-1.542 2.861 3.739-4.486 3.192a2.06 2.06 0 0 1-2.467-.06l-11.387-8.967a2.695 2.695 0 0 1-1.604.083 2.695 2.695 0 0 1-1.71-3.884 2.701 2.701 0 0 1 4.189-.722c.406.367.69.849.815 1.382z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.145 149.345a1.154 1.154 0 0 1 .568-.776l5.068-2.828a3.216 3.216 0 0 1 4.5.572 3.2 3.2 0 0 1-.561 4.494l-4.04 4.188a1.164 1.164 0 0 1-.896.352 1.151 1.151 0 0 1-.853-.448l-3.569-4.617a1.136 1.136 0 0 1-.211-.445 1.134 1.134 0 0 1-.006-.492z",
    fill: "#85B440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.945 142.568c3.487 0 6.314-2.822 6.314-6.303 0-3.48-2.827-6.302-6.314-6.302s-6.314 2.822-6.314 6.302c0 3.481 2.827 6.303 6.314 6.303z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.093 166.878a1.17 1.17 0 0 1-.187-.015l-13.664-2.236a1.153 1.153 0 0 1-.944-1.379l.665-3.128c-.341-.507-3.112-4.913.263-9.052a5.641 5.641 0 0 1 1.429-4.006 5.664 5.664 0 0 1 3.824-1.875l7.061-.536a5.694 5.694 0 0 1 4.817 2.047 5.663 5.663 0 0 1 1.101 5.108l-3.237 14.174a1.158 1.158 0 0 1-1.128.898z",
    fill: "#85B440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.853 178.73a2.763 2.763 0 0 0 .405-2.297 2.744 2.744 0 0 0-1.503-1.786l-7.78-23.876-4.508 2.136 8.512 23.248a2.766 2.766 0 0 0 1.291 3.448 2.782 2.782 0 0 0 3.583-.873z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.696 154.746-5.986 1.805a1.233 1.233 0 0 1-1.022-.14 1.237 1.237 0 0 1-.561-.863l-.909-6.157a3.436 3.436 0 0 1 2.313-4.261 3.44 3.44 0 0 1 4.276 2.295l2.651 5.611a1.234 1.234 0 0 1-.762 1.71z",
    fill: "#85B440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.808 136.508a7.838 7.838 0 0 0 8.28-1.736c-.662 1.747-.477 9.154-.477 9.154s5.873-2.783 6.67-3.27c4.706-2.875-1.784-15.381-7.184-13.409-.914.334-1.678.727-2.048 1.626-.806-.992-2.333-1.208-3.507-.698-1.173.51-2.008 1.615-2.457 2.812a7.016 7.016 0 0 0 .513 5.931l.21-.41z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.229 149.977c33.011 0 59.771-33.574 59.771-74.989C296 33.573 269.24 0 236.229 0c-33.011 0-59.771 33.573-59.771 74.988s26.76 74.989 59.771 74.989z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.69 24.902c12.978 38.084-1.111 82.156-31.467 98.437-23.617 12.667-51.044 4.989-68.129-19.071 12.975 38.085 48.103 55.762 78.46 39.483 30.357-16.279 44.447-60.35 31.471-98.435a79.548 79.548 0 0 0-10.335-20.414z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.393 59.664h.164l2.956 169.157h-6.24l3.12-169.157z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.899 170.714-9.88 5.192 1.377 2.611 9.88-5.193-1.377-2.61z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.156 167.462c25.492 0 46.157-25.82 46.157-57.671 0-31.85-20.665-57.67-46.157-57.67C20.665 52.121 0 77.941 0 109.791c0 31.851 20.665 57.671 46.156 57.671z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.49 71.273c10.021 29.289-.858 63.183-24.299 75.704-18.238 9.741-39.417 3.837-52.61-14.667 10.02 29.29 37.145 42.885 60.587 30.365s34.323-46.413 24.303-75.703a61.095 61.095 0 0 0-7.98-15.699z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.283 98.195h.127l2.282 130.626h-4.818l2.409-130.626z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.624 185.826-7.63 4.01 1.063 2.016 7.63-4.01-1.063-2.016zM270.257 229.001H7.495a.338.338 0 0 1-.337-.337.338.338 0 0 1 .337-.336h262.762a.338.338 0 0 1 .336.336.335.335 0 0 1-.336.337z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 103a5.998 5.998 0 0 1-5.885-7.17 6.004 6.004 0 0 1 4.714-4.715A6.001 6.001 0 0 1 126 97a6.012 6.012 0 0 1-1.759 4.241A6.011 6.011 0 0 1 120 103zm0-11.636a5.633 5.633 0 0 0-5.207 3.48 5.638 5.638 0 0 0 4.107 7.685 5.63 5.63 0 0 0 5.786-2.398 5.629 5.629 0 0 0-.702-7.115A5.645 5.645 0 0 0 120 91.364zM133.5 117a3.494 3.494 0 0 1-1.944-.59 3.495 3.495 0 0 1-1.489-3.593 3.505 3.505 0 0 1 2.75-2.75 3.495 3.495 0 0 1 3.593 1.489 3.494 3.494 0 0 1-.436 4.418A3.504 3.504 0 0 1 133.5 117zm0-6.788a3.293 3.293 0 0 0-3.038 2.03 3.292 3.292 0 0 0 .713 3.583 3.29 3.29 0 0 0 5.613-2.325 3.294 3.294 0 0 0-3.288-3.288zM125.5 127a1.495 1.495 0 0 1-1.386-.926 1.504 1.504 0 0 1 .325-1.635 1.507 1.507 0 0 1 1.635-.325A1.503 1.503 0 0 1 127 125.5a1.5 1.5 0 0 1-1.5 1.5zm0-2.909a1.41 1.41 0 1 0 0 2.817 1.41 1.41 0 0 0 0-2.817z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 67.5,
    r: 17.25,
    stroke: "#3F3D56",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h296v229H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/no_access.1e10354d720f9e7fb11a8fd4e0dbb73a.svg";
export { ForwardRef as ReactComponent };